import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { Table, Modal, Button, notification, Input, Form } from "antd";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { baseApiUrl } from "../../services/api";



const Contacts = () => {
  const [contacts, setContacts] = useState([]);
  const [isViewModalVisible, setIsViewModalVisible] = useState(false);
  const [isReplyModalVisible, setIsReplyModalVisible] = useState(false);
  const [viewingContact, setViewingContact] = useState(null);
  const [replyingContact, setReplyingContact] = useState(null);
  const [replyMessage, setReplyMessage] = useState("");
  const [replySubject, setReplySubject] = useState("");
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);

  const [replyDestinataire, setReplyDestinataire] = useState("");

  const [replyCC, setReplyCC] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const [toEmail, setToEmail] = useState('');
  const [cc, setCc] = useState('');
  const [subject, setSubject] = useState('');
  const [text, setText] = useState('');
  const [attachments, setAttachments] = useState([]);
  const [dateTime, setDateTime] = useState('');
  const [emailError, setEmailError] = useState('');
  const [ccError, setCcError] = useState('');
  const [subjectError, setSubjectError] = useState('');
  const [messageError, setMessageError] = useState('');
  const [dateTimeError, setDateTimeError] = useState('');

  // Notification utility
  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: message,
    });
  };

  // Fetch contacts from API
  // const fetchContacts = async () => {
  //   try {
  //     const response = await baseApiUrl.get(
  //       "/contact/liste"
  //     );
  //     if (!response.ok) {
  //       throw new Error(`Erreur HTTP: ${response.status}`);
  //     }
  //     const data = await response.json();
  //     setContacts(data);
  //   } catch (error) {
  //     openNotificationWithIcon("error", "Erreur lors de la récupération des contacts.");
  //   }
  // };

  const fetchContacts = async () => {
    try {
      const response = await baseApiUrl.get(
        "/contact/liste"
      );
      console.log("contact recuperé:", response);
      setContacts(response.data);
    } catch (error) {
      console.error("Erreur lors du chargement des user", error);
    }
  };



  // Send bulk emails
  // const sendEmailsToEndpoint = async () => {
  //   const emailList = contacts.map((contact) => contact.email);
  //   try {
  //     const response = await baseApiUrl.post(
  //       "/email/liste",
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify({ emails: emailList }),
  //       }
  //     );

  //     if (!response.ok) {
  //       throw new Error(`Erreur HTTP: ${response.status}`);
  //     }

  //     openNotificationWithIcon("success", "Liste des emails envoyée avec succès !");
  //   } catch (error) {
  //     openNotificationWithIcon("error", "Échec de l'envoi de la liste des emails.");
  //   }
  // };

  // Send a reply to a contact
  // const sendReply = async () => {
  //   if (!toEmail || !subject||!text) {
  //     openNotificationWithIcon("warning", "Veuillez remplir le sujet et le message.");
  //     return;
  //   }
  //   const formData = new FormData();
  //    formData.append("toEmail", toEmail);
  //    formData.append('cc', cc);
  //    formData.append('subject', subject);
  //    formData.append('text', text);
  //   console.log("Données envoyées :", formData);

  //   try {
  //     const response = await baseApiUrl.post(
  //       "/email/create",formData

  //     );

  //     console.log("donnééé:",response)

  //     if (response.status !== 200) {
  //       const errorText = await response.text();
  //       console.error("Erreur API:", errorText);
  //       throw new Error(`Erreur HTTP: ${response.status}`);
  //     }

  //     openNotificationWithIcon("success", "Réponse envoyée avec succès !");
  //     setIsReplyModalVisible(false);
  //   } catch (error) {
  //     openNotificationWithIcon("error", "Échec de l'envoi de la réponse.");
  //   }
  // };

  const sendReply = async () => {
    if (!toEmail || !subject || !text) {
      openNotificationWithIcon("warning", "Veuillez remplir le sujet et le message.");
      return;
    }

    const formData = new FormData();
    formData.append("toEmail", toEmail);
    formData.append("cc", cc);
    formData.append("subject", subject);
    formData.append("text", text);

    console.log("Données envoyées :", formData);

    try {
      const response = await baseApiUrl.post("/email/create", formData);

      console.log("Réponse de l'API :", response);

      if (response.status !== 200) {
        const errorText = await response.text();
        console.error("Erreur API :", errorText);
        throw new Error(`Erreur HTTP : ${response.status}`);
      }

      openNotificationWithIcon("success", "Réponse envoyée avec succès !");
      setIsReplyModalVisible(false);

      // Réinitialiser le formulaire
      resetForm();
    } catch (error) {
      openNotificationWithIcon("error", "Échec de l'envoi de la réponse.");
      console.error("Erreur détectée :", error.message || error);
    }
  };

  const resetForm = () => {
    setToEmail("");
    setCc("");
    setSubject("");
    setText("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let hasError = false;

    // Réinitialisation des messages d'erreurs
    setEmailError('');
    setCcError('');
    setSubjectError('');
    setMessageError('');
    setDateTimeError('');

    // Validation des champs
    // if (!email) {
    //     setEmailError('Veuillez entrer un email.');
    //     hasError = true;
    // }

    if (!subject) {
      setSubjectError('Veuillez entrer un sujet.');
      hasError = true;
    }

    if (!text) {
      setMessageError('Veuillez entrer un message.');
      hasError = true;
    }

    // if (!dateTime) {
    //     setDateTimeError('Veuillez entrer une date et une heure.');
    //     hasError = true;
    // }

    // Si des erreurs existent, ne pas soumettre le formulaire
    if (hasError) {
      return;
    }

    // Préparation des données
    const formData = new FormData();
    formData.append('toEmail', toEmail);
    formData.append('cc', cc);
    formData.append('subject', subject);
    formData.append('text', text);
    // formData.append('dateTime', dateTime);

    // Ajout des fichiers sélectionnés en pièces jointes
    if (attachments.length > 0) {
      Array.from(attachments).forEach((file) => {
        formData.append('attachmentPaths', file);
      });
    }

    // Envoi de la requête
    try {
      const response = await baseApiUrl.post(
        "/email/create",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: formData,
        }
      );

      console.log('Email envoyé :', formData);
      openNotificationWithIcon('success', 'L\'email a été envoyé avec succès.');
    } catch (error) {
      console.error('Erreur lors de l\'envoi de l\'email :', error);
      openNotificationWithIcon('error', 'Une erreur s\'est produite lors de l\'envoi de l\'email.');
    }
  };

  // Fetch contacts on component mount
  useEffect(() => {
    fetchContacts();
  }, []);

  // Filter contacts based on search term
  const filteredContacts = contacts.filter((contact) =>
    contact.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="page-wrapper">
      <div className="content container-fluid">
        <div className="page-header">
          <div className="row">
            <div className="col-sm-7 col-auto">
              {/* <h3 className="page-title">Contacts</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/admin">Accueil</Link>
                </li>
                <li className="breadcrumb-item active">Contacts</li>
              </ul><br />
              <div className="top-nav-search">
                <Input
                  placeholder="Rechercher par nom"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            {/* <div className="col-sm-5 col-auto text-end">
              <Button type="primary" onClick={sendEmailsToEndpoint}>
                Envoyer mail
              </Button>
            </div> */}
            <div className="col-sm-5 col">
              <Button
              type="success"
                onClick={() => setIsAddModalVisible(true)}
                className="float-end mt-2 btn-success"
              >
                <FontAwesomeIcon icon={faEnvelope} className="me-2" /> {/* Icône ajoutée ici */}
                Envoyer mail
              </Button>
            </div>
          </div>
        </div>

        <Table
          rowKey="id"
          columns={[
            { title: "Nom", dataIndex: "name", key: "name" },
            { title: "Email", dataIndex: "email", key: "email" },
            {
              title: "Sujet",
              dataIndex: "subject",
              key: "subject",
              render: (text) => (text ? (text.length > 50 ? `${text.slice(0, 50)}...` : text) : "N/A"),
            },
            {
              title: "Actions",
              key: "actions",
              render: (text, record) => (
                <div className="text-end d-inline-flex">
                  <Button
                    className="btn btn-sm bg-success-light me-2"
                    onClick={() => {
                      setViewingContact(record);
                      setIsViewModalVisible(true);
                    }}
                  >
                    Voir
                  </Button>
                  <Button
                    className="btn btn-sm bg-primary-light"
                    onClick={() => {
                      setReplyingContact(record);
                      setReplySubject("");
                      setReplyMessage("");
                      setReplyDestinataire(record.email);
                      setToEmail(record.email);

                      setReplyCC("");
                      setIsReplyModalVisible(true);
                    }}
                  >
                    Répondre
                  </Button>
                </div>
              ),
            },
          ]}
          dataSource={filteredContacts}
        />

        {/* View Contact Modal */}
        <Modal
          title="Détails du contact"
          visible={isViewModalVisible}
          onCancel={() => setIsViewModalVisible(false)}
          footer={[
            <Button key="back" onClick={() => setIsViewModalVisible(false)}>
              Fermer
            </Button>,
          ]}
        >
          <p>
            <strong>Nom :</strong> {viewingContact?.name}
          </p>
          <p>
            <strong>Email :</strong> {viewingContact?.email}
          </p>
          <p>
            <strong>Sujet :</strong> {viewingContact?.subject}
          </p>
          <p>
            <strong>Message :</strong> {viewingContact?.message}
          </p>
        </Modal>

        {/* Reply to Contact Modal */}
        <Modal
          title={`Répondre à ${replyingContact?.name || "contact"}`}
          visible={isReplyModalVisible}
          onCancel={() => setIsReplyModalVisible(false)}
          footer={[
            <Button key="cancel" onClick={() => setIsReplyModalVisible(false)}>
              Annuler
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={sendReply}
            >
              Envoyer
            </Button>,
          ]}
        >
          <Form layout="vertical">
            <Form.Item label="Destinataire">
              <Input
                value={toEmail}
                disabled
                // style={{ backgroundColor: "#e9ecef", cursor: "not-allowed" }}
                // onChange={(e) => setReplyDestinataire(e.target.value)}
                placeholder="Sujet du mail"
              />
            </Form.Item>
            <Form.Item label="Objet">
              <Input
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                placeholder="Sujet du mail"
              />
            </Form.Item>
            <Form.Item label="CC (optionnel)">
              <Input
                value={cc}
                onChange={(e) => setCc(e.target.value)}
                placeholder="Adresse(s) CC"
              />
            </Form.Item>
            <Form.Item label="Message">
              <Input.TextArea
                value={text}
                onChange={(e) => setText(e.target.value)}
                rows={4}
                placeholder="Écrivez votre réponse ici"
              />
            </Form.Item>
          </Form>
        </Modal>


        {/* Add Contact Modal */}
        <Modal
          title="Envoyé un mail"
          visible={isAddModalVisible}
          onCancel={() => setIsAddModalVisible(false)}
          footer={[
            <Button key="cancel" onClick={() => setIsAddModalVisible(false)}>
              Annuler
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={sendReply}
            >
              Envoyer
            </Button>,
          ]}
        >
          <Form layout="vertical">
            <Form.Item label="Destinataire">
              <Input
                value={toEmail}
                onChange={(e) => setToEmail(e.target.value)}
                placeholder="Sujet du mail"
              />
            </Form.Item>
            <Form.Item label="Objet">
              <Input
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                placeholder="Sujet du mail"
              />
            </Form.Item>
            <Form.Item label="CC (optionnel)">
              <Input
                value={cc}
                onChange={(e) => setCc(e.target.value)}
                placeholder="Adresse(s) CC"
              />
            </Form.Item>
            <Form.Item label="Message">
              <Input.TextArea
                value={text}
                onChange={(e) => setText(e.target.value)}
                rows={4}
                placeholder="Écrivez votre réponse ici"
              />
            </Form.Item>
          </Form>
        </Modal>


      </div>
    </div>
  );
};

export default Contacts;
